const app = {
    state: {
        loginForm: false,
        payConfirm: false,
        payOrderId:"",
        
    },
    mutations: {
        CLICK_LOGIN: (state, bol) => {
            state.loginForm = bol
        },
        PAY_CONFIRM_PAGE: (state, data) => {
            state.payConfirm = data.type
            state.payOrderId = data.orderId
        },
    
    },
    actions: {
        clickLogin({ commit }, bol) {
            commit('CLICK_LOGIN', bol)
        },
        payConfirmPage({ commit }, data) {
            commit('PAY_CONFIRM_PAGE', data)
        },
        
    }
}

export default app


// WEBPACK FOOTER //
// ./src/store/modules/app.js